import { render, staticRenderFns } from "./SearchPhrasesReport.vue?vue&type=template&id=056fbab2&lang=html"
import script from "./SearchPhrasesReport.vue?vue&type=script&lang=js"
export * from "./SearchPhrasesReport.vue?vue&type=script&lang=js"
import style0 from "./SearchPhrasesReport.vue?vue&type=style&index=0&id=056fbab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports